import React, { useCallback, useState } from 'react';
import { Divider } from 'antd';
import { RightOutlined } from '@ant-design/icons';

import { translate } from '@portal/services/i18n';
import OnboardingUserPhotoModal from '../OnboardingUserPhotoModal/OnboardingUserPhotoModal';
import Camera from '@portal/assets/svg/onboarding-icons/ic_camera.svg?react';
import Correct from '@portal/assets/svg/onboarding-icons/ic_correct.svg?react';
import { validateOnboardingDocument } from '@portal/utils/validate';

interface IProps {
  setFileSelected: (value: File) => void;
}

const OnboardingUserPhoto = ({ setFileSelected }: IProps) => {
  const [modal, setModal] = useState(false);
  const [fileSelectedModal, setFileSelectedModal] = useState(null);

  const onFileChange = (file) => {
    if (!validateOnboardingDocument(file)) {
      return;
    }

    if (
      file.target.files[0]?.type !== 'image/png' &&
      file.target.files[0]?.type !== 'image/jpeg'
    ) {
      return;
    }
    setFileSelected(file.target.files[0]);
    setFileSelectedModal(file.target.files[0]);
  };

  const handleOnClick = useCallback(() => {
    setModal(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="action-display" onClick={handleOnClick}>
        <div className="action-display__action">
          <div className="action-display__action__options">
            <Camera
              width={25}
              height={25}
              className="action-display__action__options__icon"
            />
            <div className="action-display__action__options__container">
              <p className="action-display__action__options__title">
                {translate('PAGES.AUTH.REGISTER.ONBOARD.PF.USER_PHOTO.LABEL')}
              </p>
              <p className="action-display__action__options__text">
                {translate(
                  'PAGES.AUTH.REGISTER.ONBOARD.PF.USER_PHOTO.FORM.LABEL'
                )}
              </p>
            </div>
          </div>

          <span>
            {fileSelectedModal ? (
              <Correct width={25} height={25} />
            ) : (
              <RightOutlined
                style={{
                  color: 'black',
                  fontSize: 20,
                }}
              />
            )}
          </span>
        </div>
        <Divider />
      </div>

      {modal ? (
        <OnboardingUserPhotoModal
          onCancel={() => setModal(false)}
          onFileChange={onFileChange}
          visible={modal}
          fileSelected={fileSelectedModal}
          sendType="photo"
        />
      ) : null}
    </>
  );
};

export default OnboardingUserPhoto;
